import React from 'react';

var SvgPayoutRupeeIcon = function SvgPayoutRupeeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10c0-3.038 2.462-5.5 5.5-5.5s5.5 2.462 5.5 5.5c0 .915-.223 1.777-.617 2.534-.191.368-.048.82.32 1.012.367.19.82.048 1.01-.32.503-.966.787-2.064.787-3.226 0-3.866-3.134-7-7-7s-7 3.134-7 7c0 1.162.284 2.26.786 3.226.192.368.644.51 1.012.32.367-.191.51-.644.32-1.012-.395-.757-.618-1.619-.618-2.534Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 16.25c0-.414-.336-.75-.75-.75h-13c-.414 0-.75.336-.75.75s.336.75.75.75h13c.414 0 .75-.336.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.524 13.541c.226-.347.128-.811-.22-1.037l-1.482-.967c.543-.405.902-1.043.93-1.765h.792c.414 0 .75-.337.75-.751s-.337-.75-.75-.75h-.79v-.521h.587c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.118c-.415 0-.75.336-.75.75s.335.75.75.75h1.031v.523h-1.017c-.414 0-.75.336-.75.75 0 .415.337.75.751.75h1.011c-.046.406-.391.722-.81.722-.876 0-1.214 1.14-.48 1.618l2.527 1.647c.347.226.812.128 1.038-.219Z"
  }));
};
SvgPayoutRupeeIcon.displayName = "PayoutRupeeIcon";

export { SvgPayoutRupeeIcon as S };
